// extracted by mini-css-extract-plugin
module.exports = {"stat__label":"Stat_stat__label__3SepO","stat__value":"Stat_stat__value__3IXC2"};